<template>
  <div class="api-key-icon-table-cell">
    <div class='api-key-icon-table-cell__icon'>
      <DigitalKey />
    </div>
  </div>
</template>

<script>
import DigitalKey from '@/assets/icons/digitalkey.svg?inline';

export default {
  name: 'ApiKeyIconTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  components: {
    DigitalKey,
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.api-key-icon-table-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__icon {
    max-width: rem(26) !important;
    display: flex;
    fill: var(--text-tertiary);
  }
}

</style>
